var map = {
	"./entities/middleware.js": 1142,
	"./reservation/middleware.js": 1143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1141;


//////////////////
// WEBPACK FOOTER
// ./src/store \.\/.+\/middleware\.js$
// module id = 1141
// module chunks = 0